export default __webpack_public_path__ + "static/media/placeholder.f4a07c5f.jpg";